/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import _ from 'lodash';

const domain = '/administres';
const product = '/etat-civil';

const isAvisMentionsPath =
  typeof window !== 'undefined' &&
  _.includes(window.location.hostname, 'avis-mentions');
export const baseUrlApp =
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test' ||
  isAvisMentionsPath
    ? '/'
    : `${domain}${product}/`;

export const baseUrlApi = `/api${domain}${product}`;
